import React from 'react';
import PropTypes from 'prop-types';

import { AVAILABLE_OPTIONS } from '../../../home/models/App';
import SearchInput from '../../../../common/form/SearchInput';

const FilterBar = ({ filter, setFilterQueryFn, setFilterVendorFn, setFilterTypeFn }) => {
  return (
    <div className="open-apps-filter">
      <form
        className="form"
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <SearchInput
          value={filter.query}
          onChangeFn={setFilterQueryFn}
          placeholder="Search by name, author, etc."
        />

        <div className="form-group">
          <select
            className="form-control"
            value={filter.type || ''}
            onChange={(e) =>
              e.target.value ? setFilterTypeFn(e.target.value) : setFilterTypeFn(null)
            }
          >
            {[{ name: 'All types', value: '' }].concat(AVAILABLE_OPTIONS.type).map((item) => {
              return (
                <option value={item.value} key={item.value}>
                  {item.name}
                </option>
              );
            })}
          </select>
        </div>

        <div className="checkbox">
          <label>
            <input
              checked={filter.vendor === 'keboola'}
              onChange={(e) =>
                e.target.checked ? setFilterVendorFn('keboola') : setFilterVendorFn(null)
              }
              type="checkbox"
            />{' '}
            Supported by Keboola
          </label>
        </div>
      </form>
    </div>
  );
};

FilterBar.propTypes = {
  filter: PropTypes.object.isRequired,
  setFilterQueryFn: PropTypes.func.isRequired,
  setFilterVendorFn: PropTypes.func.isRequired,
  setFilterTypeFn: PropTypes.func.isRequired,
};

export default FilterBar;
